import React from 'react';
import PropTypes from 'prop-types';

import { button, bar, label } from './styles.module.css';

/**
 * Header menu button presentational component.
 */
const HeaderMenuButton = ({ className, navId, navVisible, onClick }) => (
  <button
    className={[button, className].join(' ')}
    onClick={onClick}
    aria-controls={navId}
    aria-expanded={navVisible}
  >
    <span className={label}>Toggle navigation</span>
    <span className={bar} />
    <span className={bar} />
    <span className={bar} />
  </button>
);

HeaderMenuButton.propTypes = {
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /**
   * String ID for the target nav component.
   */
  navId: PropTypes.string,
  /**
   * Boolean whether target nav is expanded.
   */
  navVisible: PropTypes.bool,
  /**
   * Function called on button click.
   */
  onClick: PropTypes.func,
};

HeaderMenuButton.defaultProps = {
  className: '',
  navId: undefined,
  navVisible: undefined,
  onClick: () => {},
};

export default HeaderMenuButton;
